<!-- NEW DIALOG -->
@if (isDialogVisible) {
  <p-dialog [styleClass]="authService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
    header="{{ panelTitle | uppercase}}"
    [(visible)]="isDialogVisible"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="false"
    [style]="{ width: '900px' }"
    [breakpoints]="{ '992px': '95vw' }"
    >
<div [ngClass]="{'custom-form-small': authService?.user?.fontSize === 'SMALL', 'custom-form-medium': authService?.user?.fontSize === 'MEDIUM'}">
    <!-- FORM ERRORS -->
    <div #errorContainer>
      @if (errorMessages.length !== 0) {
        <div>
          @for (error of errorMessages; track error) {
            <div>
              <div class="alert alert-warning" role="alert">{{ error }}</div>
            </div>
          }
        </div>
      }
    </div>
    <!-- PANELL DADES DE VEHICLE -->
    <!-- <div class='d-flex flex-column gap-3 p-3'> -->
    <!-- <p-panel header="{{ panelTitle }}" class='w-100'> -->
    <div class="row w-100">
      <!--====== LEFT SIDE ========-->
      <div class="col-sm-6">
        <div class="mb-3">
          <!-- extra Type -->
          <form-input [required]="true" [align]="'stacked'" fieldName="{{ 'general.type' | translate }}">
            <p-select
              [options]="extrasTypeList"
              [(ngModel)]="vehicleAccessory.extrasType"
              placeholder="{{ 'general.select' | translate }}"
              dataKey="id"
              optionLabel="fullName"
              [style]="{ width: '100%' }"
              appendTo="body"
              filter="true"
              filterBy="fullName"
              (onChange)="onExtrasTypeChange($event)"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
              >
            </p-select>
          </form-input>
        </div>
        <div class="mb-3">
          <!-- description -->
          <form-input [required]="true" [align]="'stacked'" fieldName="{{ 'general.description' | translate }}">
            <input
              pInputText
              [readonly]="false"
              [(ngModel)]="vehicleAccessory.description"
              [style]="{ width: '100%' }"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
              />
          </form-input>
        </div>
        @if (
          vehicleAccessory.extrasType &&
          (vehicleAccessory.extrasType.code === 'EM' || vehicleAccessory.extrasType.code === 'AL')
          ) {
          <div class="mb-3">
            <!-- alarmType (si es alarma, code AL) -->
            @if (vehicleAccessory.extrasType.code === 'AL') {
              <form-input
                [required]="true"
                [align]="'stacked'"
                fieldName="{{ 'tableManagement.accessories.alarmType' | translate }}"
                >
                <p-select
                  [options]="alarmTypeList"
                  [(ngModel)]="vehicleAccessory.alarmType"
                  placeholder="{{ 'tableManagement.accessories.alarmType' | translate }}"
                  dataKey="id"
                  optionLabel="name"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [filter]="true"
                  filterBy="name"
                  [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
                  >
                </p-select>
              </form-input>
            }
            <!-- stationCode (si es emisora, code 10) -->
            @if (vehicleAccessory.extrasType.code === 'EM') {
              <form-input
                [required]="false"
                [align]="'stacked'"
                fieldName="{{ 'tableManagement.accessories.stationCode' | translate }}"
                >
                <input
                  pInputText
                  [readonly]="false"
                  [(ngModel)]="vehicleAccessory.stationCode"
                  [style]="{ width: '100%' }"
                  [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
                  />
              </form-input>
            }
          </div>
        }
        <div class="mb-3">
          <!-- installation date -->
          <form-input
            [required]="true"
            [align]="'stacked'"
            fieldName="{{ 'tableManagement.accessories.installationDate' | translate }}"
            >
            <p-datepicker
              [(ngModel)]="vehicleAccessory.installationDate"
              [showTime]="false"
              [style]="{ width: '100%' }"
              dateFormat="{{ i18n.dateFormat }}"
              showIcon="true"
              appendTo="body"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
            ></p-datepicker>
          </form-input>
        </div>
        <div class="mb-3">
          <!-- desinstallation date -->
          <form-input
            [required]="false"
            [align]="'stacked'"
            fieldName="{{ 'tableManagement.accessories.desinstallationDate' | translate }}"
            >
            <p-datepicker
              [(ngModel)]="vehicleAccessory.desinstallationDate"
              [showTime]="false"
              [style]="{ width: '100%' }"
              dateFormat="{{ i18n.dateFormat }}"
              showIcon="true"
              appendTo="body"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
            ></p-datepicker>
          </form-input>
        </div>
        <div class="mb-3">
          <!-- value -->
          <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'general.value' | translate }}">
            <p-inputNumber [showButtons]="true"
              [(ngModel)]="vehicleAccessory.value"
              mode="decimal"
              [min]="0"
              [minFractionDigits]="2"
              [showButtons]="true"
              [style]="{ width: '100%' }"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
            ></p-inputNumber>
          </form-input>
        </div>
      </div>
      <!--====== RIGHT SIDE ========-->
      <div class="col-sm-6">
        <div class="mb-3">
          <!-- serial Number -->
          <form-input
            [required]="false"
            [align]="'stacked'"
            fieldName="{{ 'tableManagement.accessories.serialNumber' | translate }}"
            >
            <input
              pInputText
              [readonly]="false"
              [(ngModel)]="vehicleAccessory.serialNumber"
              [style]="{ width: '100%' }"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
              />
          </form-input>
        </div>
        <div class="mb-3">
          <!-- disabled -->
          <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'general.disabled' | translate }}">
            <p-toggleSwitch #toggle [(ngModel)]="vehicleAccessory.disabled" [disabled]="isEditingDisabled || (!isNew && !updateGranted)"> </p-toggleSwitch>
          </form-input>
        </div>
        <div class="mb-3">
          <!-- verification / verificationDate -->
          <form-input
            [required]="false"
            [align]="'stacked'"
            fieldName="{{ 'tableManagement.accessories.verified' | translate }}"
            >
            <div class="d-flex align-items-center gap-2 w-100">
              <p-toggleSwitch
                #toggle
                [(ngModel)]="vehicleAccessory.verified"
                (onChange)="toggleVerified($event)"
                [disabled]="isEditingDisabled || (!allFieldsGranted && !verifiedGranted)"
                >
              </p-toggleSwitch>
              <p-datepicker [ngModel]="vehicleAccessory.verificationDate" [showTime]='true'
                (ngModelChange)="vehicleAccessory.verificationDate = $event"
                [style]="{ width: '100%' }"
                showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat="{{ i18n.dateFormat }}"
              appendTo='body'></p-datepicker>
            </div>
          </form-input>
        </div>
        <div class="mb-3">
          <!-- observations -->
          <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'general.observations' | translate }}">
            <textarea
              pInputTextarea
              id="observations"
              [(ngModel)]="vehicleAccessory.observations"
              [rows]="5"
              [style]="{ width: '100%' }"
              [disabled]="isEditingDisabled || (!isNew && !updateGranted)"
              >
            </textarea>
          </form-input>
        </div>
      </div>
    </div>
  <!-- </p-panel> -->
<!-- </div> -->
<!-- PIE DE PAGINA -->
</div>
<ng-template pTemplate="footer">
  <div class="d-flex flex-row-reverse bd-highlight">
    <div class="p-2 bd-highlight">
      <button
        type="button"
        class="btn custom-button"
        (click)="onSaveVehicleAccessory()"
        [disabled]="isEditingDisabled || !allFieldsGranted"
        >
        {{ isEditingDisabled ? ('general.saving' | translate) : ('general.save' | translate) }}
      </button>
    </div>
  </div>
</ng-template>
</p-dialog>
}
